import { useState } from 'react'
import { Button } from '../Button'
import Progressbar from '../Progressbar'
import Spinner from '../Spinner'
import { formatDuration } from '../../utils/formatDuration'
import { getFixedStaking } from '../../api/contracts'

import {
  CardButtonWrapper,
  StakeContainer,
  StakeMaturity,
  StakeMaturityItem,
  StakeMaturityItemText,
  StakeMaturityItemInfo,
  StakeMaturityItemContainer,
  StakeInfo,
  StakeInfoItem,
  StakeInfoItemText,
  StakeInfoItemTextSpan,
  StakeIconLogo,
  StakeIconLogoMaturity,
  StakeIconSkin,
} from './StakingHistoryItem.styled'

function StakingHistoryItem({
  name,
  setIsLoading,
  forceUpdate,
  staked,
  idx,
  restTimeBeforeExpire,
  stakeDuration,
  harvestable,
  charactersAmount,
  allowHarvest,
  stakedAmount,
  setUnstakeIdx,
  setUnstakeStaked,
  handleOpenUnstakeModalWindow,
  contractAddress,
}) {
  const [isHarvesting, setIsHarvesting] = useState(false)
  const [isUnstaking, setIsUnstaking] = useState(false)

  function getRewardPicture(name) {
    switch (name) {
      case 'Epic':
        return require('../../images/GoldenHelmet.svg').default
      case 'Legendary':
        return require('../../images/PinkHelmet.svg').default
      default:
        return require('../../images/GreenHelmet.svg').default
    }
  }

  const stakeCompleted =
    restTimeBeforeExpire === 0
      ? 100
      : 100 - Math.floor((restTimeBeforeExpire * 100) / stakeDuration)

  const harvestHandler = (allowHarvest, idx) => {
    const FixedStaking = getFixedStaking(contractAddress)
    if (allowHarvest) {
      setIsHarvesting(true)
      FixedStaking.harvest(idx)
        .then(tx => {
          tx.wait()
            .then(() => {
              setIsHarvesting(false)
              setIsLoading(true)
              forceUpdate()
            })
            .catch(err => {
              setIsHarvesting(false)
              console.log(err)
            })
        })
        .catch(err => {
          setIsHarvesting(false)
          console.log(err)
        })
    }
  }

  const unstakeHandler = () => {
    const FixedStaking = getFixedStaking(contractAddress)
    if (staked) {
      setIsUnstaking(true)
      FixedStaking.unstake(idx)
        .then(tx => {
          tx.wait()
            .then(() => {
              setIsUnstaking(false)
              setIsLoading(true)
              forceUpdate()
            })
            .catch(err => {
              setIsUnstaking(false)
              console.log(err)
            })
        })
        .catch(err => {
          setIsUnstaking(false)
          console.log(err)
        })
    }
  }

  return (
    <StakeContainer key={idx}>
      <StakeMaturity>
        {restTimeBeforeExpire === 0 ? (
          <img
            src={require('../../images/Finish.svg').default}
            width='32'
            height='32'
            alt='finish'
          ></img>
        ) : (
          <img
            src={require('../../images/WhiteCharacter.svg').default}
            width='32'
            height='32'
            alt='run'
          ></img>
        )}
        <StakeMaturityItem>
          <StakeMaturityItemInfo>
            <div>{formatDuration(restTimeBeforeExpire, 'short')}</div>
            <StakeMaturityItemContainer>
              <StakeMaturityItemText>Staked: </StakeMaturityItemText>
              {stakedAmount === '0' ? '~0' : stakedAmount}
              <StakeIconLogoMaturity>
                <img
                  src={require('../../images/SmallLogo.svg').default}
                  width='25'
                  height='20'
                  alt='mrn'
                ></img>
              </StakeIconLogoMaturity>
            </StakeMaturityItemContainer>
          </StakeMaturityItemInfo>
          <Progressbar completed={stakeCompleted} />
        </StakeMaturityItem>
      </StakeMaturity>
      <StakeInfo>
        <StakeInfoItem>
          <StakeInfoItemText>
            {harvestable}
            <StakeIconLogo>
              <img
                src={require('../../images/SmallLogo.svg').default}
                width='25'
                height='20'
                alt='mrn'
              ></img>
            </StakeIconLogo>
          </StakeInfoItemText>
          {isHarvesting ? (
            <CardButtonWrapper>
              <Button disabled variant='staking' size='unstaking'>
                <Spinner size='23px' />
              </Button>
            </CardButtonWrapper>
          ) : (
            <Button
              disabled={!allowHarvest}
              variant='staking'
              size='unstaking'
              onClick={() => harvestHandler(allowHarvest, idx)}
            >
              Harvest
            </Button>
          )}
        </StakeInfoItem>
        <StakeInfoItem>
          <StakeInfoItemText>
            <StakeInfoItemTextSpan>
              You got {charactersAmount}
              <StakeIconSkin>
                <img
                  src={getRewardPicture(name)}
                  width='24px'
                  height='24px'
                  alt='reward'
                ></img>
              </StakeIconSkin>
            </StakeInfoItemTextSpan>
          </StakeInfoItemText>
          {restTimeBeforeExpire === 0 && staked ? (
            <CardButtonWrapper>
              {isUnstaking ? (
                <Button disabled size='unstaking' variant='staking'>
                  <Spinner size='23px' />
                </Button>
              ) : (
                <Button
                  disabled={!staked}
                  variant='staking'
                  size='unstaking'
                  onClick={unstakeHandler}
                >
                  Unstake
                </Button>
              )}
            </CardButtonWrapper>
          ) : (
            <Button
              disabled={!staked}
              onClick={() => {
                setUnstakeIdx(idx)
                setUnstakeStaked(staked)
                handleOpenUnstakeModalWindow()
              }}
              variant='staking'
              size='unstaking'
            >
              Unstake
            </Button>
          )}
        </StakeInfoItem>
      </StakeInfo>
    </StakeContainer>
  )
}

export default StakingHistoryItem
